import { render, staticRenderFns } from "./InfoEmpikCard.vue?vue&type=template&id=511259ee"
import script from "./InfoEmpikCard.vue?vue&type=script&lang=js"
export * from "./InfoEmpikCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports